<template>
    <base-nav class="navbar-top navbar-dark"
              id="navbar-main"
              :show-toggle-button="false"
              expand>
        <!-- <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
            <div class="form-group mb-0">
                <base-input placeholder="Search"
                            class="input-group-alternative"
                            alternative=""
                            addon-right-icon="fas fa-search">
                </base-input>
            </div>
        </form> -->
        <div slot="brand">
          <a href="#" @click.prevent="$router.go(-1)">Back</a>
        </div>
        <ul class="navbar-nav align-items-center d-none d-md-flex ml-lg-auto">
            <li class="nav-item dropdown">
                <base-dropdown class="nav-link pr-0">
                    <div class="media align-items-center" slot="title">
                <span class="avatar avatar-sm rounded-circle">
                  <img alt="Image placeholder" :src="avatarUrl">
                </span>
                        <div class="media-body ml-2 d-none d-lg-block">
                            <span class="mb-0 text-sm  font-weight-bold">{{$store.state.user.Name}}</span>
                        </div>
                    </div>

                    <template>
                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">Welcome!</h6>
                        </div>
                        <div class="dropdown-item" @click="logout">
                            <i class="ni ni-user-run"></i>
                            <span>Logout</span>
                        </div>
                    </template>
                </base-dropdown>
            </li>
        </ul>
    </base-nav>
</template>
<script>
import AvatarHelper from '@/helpers/Avatars.js';

export default {
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchQuery: '',
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.user;
    },
    avatarUrl() {
      if (this.currentUser) {
        return AvatarHelper.getAvatar(this.currentUser);
      }
      return '';
    },
    route() {
      console.log(this.$store.state.route);
      return this.$store.state.route;
    },
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    logout() {
      this.$store.commit('setAuthToken', null);
      this.$store.commit('setUser', null);
      window.localStorage.removeItem('northswing-token');
      window.localStorage.removeItem('northswing-user');
      this.$router.push({ name: 'login' });
    },
  },
};
</script>
